<template>
  <WdsInput
    v-if="!timesheetFormStore.isViewOnly"
    v-model="timesheetFormStore.tableDateEntries[col.dateString][row.entriesKey]"
    :data-test="`${col.dateString}-${row.entriesKey}`"
    class="tw-w-full"
    type="number"
    step="0.25"
    :max="timesheetFormStore.useDayInputs ? 1 : 24"
    min="0"
    :disabled="timesheetFormStore.isDateDisabled(col.dateString)"
    :class="{
      'timesheet-day-total':
        !timesheetFormStore.isDateDisabled(col.dateString) &&
        !getErrorMessage(col.dateString, row.entriesKey) &&
        timesheetFormStore.tableDateEntries[col.dateString][row.entriesKey],
    }"
    :error="getErrorMessage(col.dateString, row.entriesKey)"
    @keydown="handleKeydown"
    @blur="inputTouched(col.dateString, row.entriesKey)"
    @focus="inputFocused(col.dateString, row.entriesKey)"
  />
  <WdsInput
    v-else
    v-model="timesheetFormStore.tableDateEntries[col.dateString][row.entriesKey]"
    disabled
    class="tw-w-full"
    type="number"
    min="0"
    :max="timesheetFormStore.useDayInputs ? 1 : 24"
    :class="{
      'timesheet-day-total':
        !timesheetFormStore.isDateDisabled(col.dateString) &&
        !getErrorMessage(col.dateString, row.entriesKey) &&
        timesheetFormStore.tableDateEntries[col.dateString][row.entriesKey],
    }"
  />
</template>

<script setup lang="ts">
import { WdsInput } from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'
import { useTimesheetFormStore } from '@/components/Timesheet/store/useTimesheetFormStore'
import { useValidationStore } from '@/components/Timesheet/store/useValidationStore'

interface Props {
  row: any
  col: any
}

const props = defineProps<Props>()

const { $t } = useTranslation()
const timesheetFormStore = useTimesheetFormStore()
const timesheetValidationStore = useValidationStore()

const getErrorMessage = (columnDate, entryKey) =>
  timesheetValidationStore.v$[columnDate]?.[entryKey]?.$errors[0]?.$message

const handleKeydown = (event) => {
  if (event.key === '-') {
    event.preventDefault()
  }
}

const resetDurationEntry = (dateKey: string, fieldKey: string, value: number | null) => {
  if (
    timesheetFormStore.tableDateEntries[dateKey] !== undefined &&
    !timesheetFormStore.tableDateEntries[dateKey][fieldKey]
  ) {
    timesheetFormStore.tableDateEntries[dateKey][fieldKey] = value
  }
}
const inputTouched = (dateKey, fieldKey) => {
  if (
    !!timesheetFormStore.tableDateEntries[dateKey]?.startTime &&
    !!timesheetFormStore.tableDateEntries[dateKey]?.endTime
  ) {
    timesheetValidationStore.v$[dateKey]?.$touch()
  }

  resetDurationEntry(dateKey, fieldKey, 0)
}

const inputFocused = (dateKey: string, fieldKey: string) => {
  resetDurationEntry(dateKey, fieldKey, null)
}
</script>
